import React from 'react'
import PurchaseSummary from './PurchaseSummary'

export default function PostedFishPurSummary() {
    return (
        <PurchaseSummary xState={'POST'} />
    )
}
